import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { CartDrawer } from '@components/cart/CartDrawer';
import { Footer } from '@components/layout/Footer';
import { Header } from '@components/layout/Header';
import { ContactPage } from '@pages/ContactPage';
import { CheckoutPage } from '@pages/CheckoutPage';
import { ConsentPage } from '@pages/ConsentPage';
import { DownloadsPage } from '@pages/DownloadsPage';
import { HomePage } from '@pages/HomePage';
import { LegalPage } from '@pages/LegalPage';
import { NotFoundPage } from '@pages/NotFoundPage';
import { ProductDetailPage } from '@pages/ProductDetailPage';
import { ProductsPage } from '@pages/ProductsPage';
import { ServicesPage } from '@pages/ServicesPage';
import { ThankYouPage } from '@pages/ThankYouPage';
import { AdminPage } from '@pages/AdminPage';
export const App = () => {
    const { pathname } = useLocation();
    if (pathname === '/admin' || pathname.startsWith('/admin/')) {
        return (_jsxs(AppShell, { children: [_jsx(NavigationFocus, {}), _jsx(Routes, { children: _jsx(Route, { path: "/admin/*", element: _jsx(AdminPage, {}) }) })] }));
    }
    return (_jsxs(AppShell, { children: [_jsx(NavigationFocus, {}), _jsx(Header, {}), _jsx("main", { id: "main-content", tabIndex: -1, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/services", element: _jsx(ServicesPage, {}) }), _jsx(Route, { path: "/products", element: _jsx(ProductsPage, {}) }), _jsx(Route, { path: "/products/:slug", element: _jsx(ProductDetailPage, {}) }), _jsx(Route, { path: "/contact", element: _jsx(ContactPage, {}) }), _jsx(Route, { path: "/checkout", element: _jsx(CheckoutPage, {}) }), _jsx(Route, { path: "/consent", element: _jsx(ConsentPage, {}) }), _jsx(Route, { path: "/downloads", element: _jsx(DownloadsPage, {}) }), _jsx(Route, { path: "/order-confirmation", element: _jsx(ThankYouPage, {}) }), _jsx(Route, { path: "/legal", element: _jsx(LegalPage, { titleKey: "legalPages.legal", contentKey: "legal" }) }), _jsx(Route, { path: "/privacy", element: _jsx(LegalPage, { titleKey: "legalPages.privacy", contentKey: "privacy" }) }), _jsx(Route, { path: "/cookies", element: _jsx(LegalPage, { titleKey: "legalPages.cookies", contentKey: "cookies" }) }), _jsx(Route, { path: "/terms", element: _jsx(LegalPage, { titleKey: "legalPages.terms", contentKey: "terms" }) }), _jsx(Route, { path: "/refund-policy", element: _jsx(LegalPage, { titleKey: "legalPages.refundPolicy", contentKey: "refundPolicy" }) }), _jsx(Route, { path: "*", element: _jsx(NotFoundPage, {}) })] }) }), _jsx(Footer, {}), _jsx(CartDrawer, {})] }));
};
const NavigationFocus = () => {
    const { pathname } = useLocation();
    const previousPath = useRef(pathname);
    useEffect(() => {
        if (previousPath.current !== pathname) {
            window.scrollTo({ top: 0, behavior: 'instant' });
            document.getElementById('main-content')?.focus({ preventScroll: true });
            previousPath.current = pathname;
        }
    }, [pathname]);
    return null;
};
const AppShell = styled.div `
  min-height: 100vh;
`;
